import { Button as MuiButton } from "@mui/material";
import { Spin } from "../Spin";
import classes from "./style.module.scss";

export const Button = ({
  size = "medium",
  color = "primary",
  variant = "rounded",
  loading = false,
  loadingText = "",
  className = "",
  fullWidth = false,
  children,
  ...rest
}) => {
  const sizeClass = classes[`button_${size}`] || "";
  const colorClass = classes[`button_${color}`] || "";
  const variantClass = classes[`button_${variant}`] || "";

  return (
    <MuiButton
      {...rest}
      className={[
        classes.button,
        className,
        sizeClass,
        colorClass,
        variantClass,
        fullWidth ? classes.fullWidth : "",
      ].join(" ")}
      disabled={rest?.disabled || loading}
    >
      {loading ? (
        <>
          <Spin className={classes.spin} size={16} />
          {loadingText}
        </>
      ) : (
        children
      )}
    </MuiButton>
  );
};
